import { render, staticRenderFns } from "./UploadResourcePhoto.vue?vue&type=template&id=0844a542&"
import script from "./UploadResourcePhoto.vue?vue&type=script&lang=js&"
export * from "./UploadResourcePhoto.vue?vue&type=script&lang=js&"
import style0 from "./UploadResourcePhoto.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports